<div style="margin-left: 4%; margin-right: 4%">
  <div style="margin-top: 1.875rem">
    <span class="chargingProjectHeader">Charging Project Setup</span>
  </div>
</div>
<div style="margin-left: 3.2%">
  <div style="display: inline-block; margin-top: 1.563rem; margin-left: 1.563rem">
    <mat-form-field class="fundingFields" style="pointer-events: none">
      <input [(ngModel)]="fundingProjectID" placeholder="Funding Project ID" matInput />
    </mat-form-field>
  </div>
  <div style="display: inline-block; margin-left: 2.5rem">
    <mat-form-field class="fundingFields" style="pointer-events: none">
      <mat-select [compareWith]="compareState" [(value)]="state" placeholder="State">
        @for (option of stateOptions; track option) {
          <mat-option style="color: #696969" [value]="option"
            ><span>{{ option.state }}</span></mat-option
          >
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div style="display: inline-block; margin-left: 2.5rem">
    <mat-form-field class="fundingFields" style="pointer-events: none">
      <mat-select [(value)]="businessUnit" placeholder="Business Unit">
        @for (option of businessUnitOptions; track option) {
          <mat-option style="color: #696969" [value]="option"
            ><span>{{ option }}</span></mat-option
          >
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div
    style="
      display: inline-block;
      float: right;
      margin-right: 3.5%;
      background-color: #f3fafd;
      width: 16rem;
      height: 5.656rem;
      text-align: center;
    "
  >
    <div style="margin-top: 1.563rem">
      <mat-form-field style="background: white; padding-left: 0.4rem; padding-right: 0.4rem">
        <mat-label>Estimated Start Date</mat-label>
        <input
          matInput
          [matDatepicker]="startDatePicker"
          [(ngModel)]="estimatedStartDate"
          style="color: #696969"
          [min]="todayDate"
          [max]="estimatedInServiceDate"
        />
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</div>
<div>
  <div
    style="
      display: inline-block;
      background-color: #f3fafd;
      width: 34.625rem;
      height: 5.625rem;
      text-align: center;
      margin-left: 3.5%;
    "
  >
    <div>
      <mat-form-field class="fundingFields" style="width: 31.25rem; margin-top: 1rem">
        <input [(ngModel)]="projectName" placeholder="Project Name" matInput maxlength="35" />
      </mat-form-field>
    </div>
  </div>
  <div
    style="
      display: inline-block;
      background-color: #f3fafd;
      padding-right: 1.25rem;
      padding-bottom: 0.563rem;
    "
  >
    <mat-form-field class="fundingFields" style="width: 7.5rem; margin-top: 1rem">
      <mat-select [(value)]="operatingUnit" placeholder="Operating Unit">
        @for (option of operatingUnitOptions; track option) {
          <mat-option style="color: #696969" [value]="option"
            ><span>{{ option.OPERATING_UNIT }} - {{ option.DESCR }}</span></mat-option
          >
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div style="display: inline-block; margin-left: 0.3rem">
    <mat-form-field
      class="fundingFields"
      style="width: 14.063rem; margin-top: 1rem; pointer-events: none"
    >
      <input [(ngModel)]="projectManager" placeholder="Project Manager" matInput />
    </mat-form-field>
  </div>
  <div
    style="
      display: inline-block;
      float: right;
      margin-right: 3.5%;
      background-color: #f3fafd;
      width: 16rem;
      height: 5.656rem;
      text-align: center;
    "
  >
    <div style="margin-top: 1rem">
      <mat-form-field style="background: white; padding-left: 0.4rem; padding-right: 0.4rem">
        <mat-label>Estimated In Service Date</mat-label>
        <input
          matInput
          [matDatepicker]="inServiceDatePicker"
          [(ngModel)]="estimatedInServiceDate"
          [min]="minimumInServiceDate()"
          style="color: #696969"
        />
        <mat-datepicker-toggle matSuffix [for]="inServiceDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #inServiceDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</div>
<div style="display: inline-block; width: 100%">
  <div
    style="
      display: inline-block;
      background-color: #f3fafd;
      width: 56.625rem;
      height: 27.625rem;
      text-align: center;
      margin-left: 3.5%;
      margin-top: 1.188rem;
    "
    [class.removeBackground]="longDescriptionSubmitted"
  >
    <div style="float: left; margin-top: 1.5rem; margin-left: 1.25rem; margin-bottom: 0.25rem">
      <span style="color: #696969"
        >Project Long Description
        @if (!longDescriptionSubmitted) {
          <span>(initially from Funding Project Scope)</span>
        }
      </span>
    </div>
    <textarea
      [(ngModel)]="projectLongDescription"
      [readonly]="longDescriptionSubmitted"
      maxlength="254"
      class="textBox"
      style="width: 52.688rem; height: 19.688rem"
    >
    </textarea>
    <mat-checkbox
      color="primary"
      style="float: right; margin-right: 1.25rem"
      [class.hideElements]="longDescriptionSubmitted"
      [checked]="longDescriptionComplete"
      (change)="longDescriptionCompleteToggle()"
    >
      <span style="color: #00789e">Project Long Description complete</span>
    </mat-checkbox>
  </div>
  <div
    style="
      display: inline-block;
      float: right;
      margin-right: 3.5%;
      background-color: #f3fafd;
      width: 16rem;
      height: 5.656rem;
      text-align: center;
      padding-bottom: 1.688rem;
    "
  >
    <div style="margin-top: 1.563rem">
      <mat-form-field
        style="background: white; padding-left: 0.4rem; padding-right: 0.4rem; width: 12.5rem"
      >
        <mat-label>Cost Estimate</mat-label>
        <input
          type="number"
          min="0"
          step=".01"
          matInput
          [(ngModel)]="costEstimate"
          style="color: #696969"
        />
      </mat-form-field>
    </div>
  </div>
</div>
<div
  style="width: 100%; text-align: center; margin-top: 1.563rem"
  [class.hideElements]="!longDescriptionSubmitted"
>
  <div
    style="width: 93%; height: 18.563rem; background-color: #f3fafd; display: block; margin: auto"
  >
    <div
      style="
        text-align: left;
        width: 31%;
        margin-left: 1.625rem;
        margin-top: 1.25rem;
        display: inline-block;
        float: left;
      "
    >
      <div>
        <span style="color: #696969">PowerPlan Project Type</span>
      </div>
      <div style="width: 100%; height: 14.25rem; background-color: white; margin-top: 0.5rem">
        <div style="height: 1.563rem; padding-top: 0.75rem">
          <span style="font-size: 0.875rem; color: #696969; margin-right: 0.5rem; float: right"
            >Confidence</span
          >
        </div>
        <mat-radio-group [(ngModel)]="powerPlanProjectType" (change)="getActivities()">
          @for (option of workOrderTypeOptions; track option) {
            <div style="margin-left: 0.938rem; margin-bottom: 1.2rem">
              <mat-radio-button
                color="primary"
                [value]="option"
                style="display: inline-block"
                (click)="closeAdditionalProjectTypes()"
              >
                <div style="display: inline-block; color: #696969">{{ option.description }}</div>
              </mat-radio-button>
              <div
                style="
                  display: inline-block;
                  color: #696969;
                  float: right;
                  width: 4.688rem;
                  text-align: center;
                "
              >
                {{ option.cosim }}%
              </div>
            </div>
          }
          <mat-radio-button
            color="primary"
            [value]="additionalSelectedProjectType"
            style="display: inline-block"
            style="margin-left: 0.938rem; margin-top: -0.75rem"
            (click)="openAdditionalProjectTypes()"
          >
            @if (!(additionalSelectedProjectType && additionalSelectedProjectType.description)) {
              <div style="display: inline-block; color: #696969">
                <span class="fullListOption"
                  >I don’t like these options, show full list for the BU</span
                >
              </div>
            }
            @if (additionalSelectedProjectType && additionalSelectedProjectType.description) {
              <div style="display: inline-block; color: #696969">
                <span class="fullListOption">{{ additionalSelectedProjectType.description }}</span>
              </div>
            }
          </mat-radio-button>
          <div
            class="additionalOptions"
            [class.visibleOptions]="additionalProjectTypeVisible"
            style="overflow-y: auto"
          >
            <mat-radio-group [(ngModel)]="additionalSelectedProjectType">
              @for (option of additionalWorkOrderTypes; track option) {
                <div>
                  <mat-radio-button
                    color="primary"
                    [value]="option"
                    class="additionalButton"
                    style="display: inline-block"
                    style="margin-left: 0.938rem"
                    (click)="closeAdditionalProjectTypes(option); getActivities()"
                  >
                    <div style="display: inline-block; color: #696969">
                      <span class="fullListOption">{{ option.description }}</span>
                    </div>
                  </mat-radio-button>
                  <div
                    style="
                      border-bottom: 0.063rem solid #c9c9c9;
                      padding-top: 0.2rem;
                      width: 92%;
                      margin: auto;
                    "
                  ></div>
                </div>
              }
            </mat-radio-group>
          </div>
        </mat-radio-group>
      </div>
    </div>
    <div
      style="
        text-align: left;
        width: 31%;
        margin-left: 1.625rem;
        margin-top: 1.25rem;
        display: inline-block;
        float: left;
      "
    >
      <div>
        <span style="color: #696969">Major Location</span>
      </div>
      <div style="width: 100%; height: 14.25rem; background-color: white; margin-top: 0.5rem">
        <div style="height: 1.563rem; padding-top: 0.75rem">
          <span
            style="font-size: 0.875rem; color: #696969; margin-right: 0.5rem; float: right"
          ></span>
        </div>
        <mat-radio-group [(ngModel)]="majorLocation" (change)="getAssetLocationChoices()">
          @for (option of majorLocationOptions; track option) {
            <div style="margin-left: 0.938rem; margin-bottom: 1.2rem">
              <mat-radio-button
                color="primary"
                [value]="option"
                style="display: inline-block"
                (click)="closeAdditionalMajorLocations()"
              >
                <div style="display: inline-block; color: #696969">{{ option.major_location }}</div>
              </mat-radio-button>
            </div>
          }
          <mat-radio-button
            color="primary"
            [value]="additionalSelectedMajorLocation"
            style="display: inline-block"
            style="margin-left: 0.938rem; margin-top: -0.75rem"
            (click)="openAdditionalMajorLocations()"
          >
            @if (
              !(additionalSelectedMajorLocation && additionalSelectedMajorLocation.major_location)
            ) {
              <div style="display: inline-block; color: #696969">
                <span class="fullListOption"
                  >I don’t like this option, show full list for the BU</span
                >
              </div>
            }
            @if (
              additionalSelectedMajorLocation && additionalSelectedMajorLocation.major_location
            ) {
              <div style="display: inline-block; color: #696969">
                <span class="fullListOption">{{
                  additionalSelectedMajorLocation.major_location
                }}</span>
              </div>
            }
          </mat-radio-button>
          <div
            class="additionalOptions"
            [class.visibleOptions]="additionalMajorLocationVisible"
            style="overflow-y: auto"
          >
            <mat-radio-group [(ngModel)]="additionalSelectedMajorLocation">
              @for (option of additionalMajorLocations; track option) {
                <div>
                  <mat-radio-button
                    color="primary"
                    [value]="option"
                    class="additionalButton"
                    style="display: inline-block"
                    style="margin-left: 0.938rem"
                    (click)="closeAdditionalMajorLocations(option); getAssetLocationChoices()"
                  >
                    <div style="display: inline-block; color: #696969">
                      <span class="fullListOption">{{ option.major_location }}</span>
                    </div>
                  </mat-radio-button>
                  <div
                    style="
                      border-bottom: 0.063rem solid #c9c9c9;
                      padding-top: 0.2rem;
                      width: 92%;
                      margin: auto;
                    "
                  ></div>
                </div>
              }
            </mat-radio-group>
          </div>
        </mat-radio-group>
      </div>
    </div>
    <div
      style="
        text-align: left;
        width: 31%;
        margin-left: 1.625rem;
        margin-top: 1.25rem;
        display: inline-block;
        float: left;
      "
    >
      <div>
        <span style="color: #696969">Project Charge Indicator</span>
      </div>
      <div style="width: 100%; height: 14.25rem; background-color: white; margin-top: 0.5rem">
        <div style="height: 1.563rem; padding-top: 0.75rem">
          <span style="font-size: 0.875rem; color: #696969; margin-right: 0.5rem; float: right"
            >Confidence</span
          >
        </div>
        <mat-radio-group [(ngModel)]="projectChargeIndicator">
          @for (option of chargeIndicatorOptions; track option) {
            <div style="margin-left: 0.938rem; margin-bottom: 1.2rem">
              <mat-radio-button
                color="primary"
                [value]="option.chargeIndicatorName"
                style="display: inline-block"
                (click)="closeAdditionalIndicators()"
              >
                <div style="display: inline-block; color: #696969">
                  {{ option.chargeIndicatorName }}
                </div>
              </mat-radio-button>
              <div
                style="
                  display: inline-block;
                  color: #696969;
                  float: right;
                  width: 4.688rem;
                  text-align: center;
                "
              >
                {{ option.confidence }}%
              </div>
            </div>
          }
          <mat-radio-button
            color="primary"
            [value]="additionalSelectedIndicator"
            style="display: inline-block"
            style="margin-left: 0.938rem; margin-top: -0.75rem"
            (click)="openAdditionalIndicators()"
          >
            @if (!additionalSelectedIndicator) {
              <div style="display: inline-block; color: #696969">
                <span class="fullListOption"
                  >I don’t like these options, show full list for the BU</span
                >
              </div>
            }
            @if (additionalSelectedIndicator) {
              <div style="display: inline-block; color: #696969">
                <span class="fullListOption">{{ additionalSelectedIndicator }}</span>
              </div>
            }
          </mat-radio-button>
          <div
            class="additionalOptions"
            [class.visibleOptions]="additionalIndicatorVisible"
            style="overflow-y: auto"
          >
            <mat-radio-group [(ngModel)]="additionalSelectedIndicator">
              @for (option of additionalChargeIndicatorOptions; track option) {
                <div>
                  <mat-radio-button
                    color="primary"
                    [value]="option.chargeIndicatorName"
                    class="additionalButton"
                    style="display: inline-block"
                    style="margin-left: 0.938rem"
                    (click)="closeAdditionalIndicators(option)"
                  >
                    <div style="display: inline-block; color: #696969">
                      <span class="fullListOption">{{ option.chargeIndicatorName }}</span>
                    </div>
                  </mat-radio-button>
                  <div
                    style="
                      border-bottom: 0.063rem solid #c9c9c9;
                      padding-top: 0.2rem;
                      width: 92%;
                      margin: auto;
                    "
                  ></div>
                </div>
              }
            </mat-radio-group>
          </div>
        </mat-radio-group>
      </div>
    </div>
  </div>
</div>
<div
  style="width: 100%; text-align: center; margin-top: 1.563rem"
  [class.hideElements]="!longDescriptionSubmitted"
>
  <div style="width: 93%; height: 6.25rem; background-color: #f3fafd; display: block; margin: auto">
    <div
      style="
        display: inline-block;
        background-color: #f3fafd;
        width: 39.625rem;
        height: 5.625rem;
        text-align: center;
        float: left;
        margin-left: 0.313rem;
      "
    >
      <div>
        <mat-form-field
          class="fundingFields"
          style="width: 36.313rem; margin-top: 1rem"
          [class.genericDisabled]="!assetLocationsFound"
        >
          <mat-select
            [(value)]="assetLocation"
            placeholder="Asset Location"
            [compareWith]="compareAssetLocation"
          >
            @for (option of assetLocationOptions; track option) {
              <mat-option style="color: #696969" [value]="option"
                ><span>{{ option.long_description }}</span></mat-option
              >
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div
      style="
        display: inline-block;
        background-color: #f3fafd;
        width: 16.2rem;
        height: 5.625rem;
        text-align: center;
        float: left;
        margin-left: 0.313rem;
      "
    >
      <div>
        <mat-form-field class="fundingFields" style="width: 15.5rem; margin-top: 1rem">
          <input
            type="text"
            placeholder="Resp Center"
            matAutocompletePosition="below"
            matInput
            [matAutocomplete]="auto1"
            [formControl]="respCenterControl"
            [(ngModel)]="respCenter"
          />
        </mat-form-field>
        <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayFnRespCenter">
          @for (option of filteredRespCenterOptions | async; track option) {
            <mat-option style="color: #696969" [value]="option"
              ><span>{{ option.DEPARTMENT_ID }} - {{ option.DESCR }}</span></mat-option
            >
          }
        </mat-autocomplete>
      </div>
    </div>
    <div
      style="
        display: inline-block;
        background-color: #f3fafd;
        width: 25.75rem;
        height: 5.625rem;
        text-align: center;
        float: left;
        margin-left: 1.8rem;
      "
    >
      <div>
        <mat-form-field class="fundingFields" style="width: 25.75rem; margin-top: 1rem">
          <input
            type="text"
            placeholder="Contract Admin"
            matAutocompletePosition="below"
            matInput
            [matAutocomplete]="auto2"
            [formControl]="contractAdminControl"
            [(ngModel)]="contractAdmin"
          />
        </mat-form-field>
        <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFnContractAdmin">
          @for (option of filteredContractAdminOptions | async; track option) {
            <mat-option style="color: #696969" [value]="option"
              ><span>{{ option.full_name }}</span></mat-option
            >
          }
        </mat-autocomplete>
      </div>
    </div>
  </div>
</div>
<div style="margin-bottom: 4.375rem; margin-top: 3.75rem">
  <div class="startOverButton" (click)="goToPreviousPage()">
    <span style="font-size: 0.875rem; color: #00789e">PREVIOUS PAGE</span>
  </div>
  <div style="display: inline-block">
    <div class="exitButton" (click)="exitPage()">
      <span class="exitText">EXIT</span>
    </div>
  </div>
  <div style="display: inline-block; float: right">
    <div style="display: inline-block">
      <button
        class="confirmButton"
        (click)="launchActivityDialog()"
        [disabled]="continueDisabled() || loadingChargeIndicator"
        [class.buttonDisabled]="continueDisabled() || loadingChargeIndicator"
      >
        @if (!loadingChargeIndicator) {
          <span class="confirmText">CONTINUE</span>
        }
        @if (loadingChargeIndicator) {
          <div class="dot-spin" style="margin: auto"></div>
        }
      </button>
    </div>
  </div>
</div>
